import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconTimeElapsedComponent } from './components/icon-time-elapsed/icon-time-elapsed.component';
import { IconGoalComponent } from './components/icon-goal/icon-goal.component';
import { IconUsersOnlineComponent } from './components/icon-users-online/icon-users-online.component';
import { IconAuctionComponent } from './components/icon-auction/icon-auction.component';
import { IconDonationComponent } from './components/icon-donation/icon-donation.component';
import { IconLastHeroComponent } from './components/icon-last-hero/icon-last-hero.component';
import { IconSilentComponent } from './components/icon-silent/icon-silent.component';
import { IconStatusLobbyComponent } from './components/icon-status-lobby/icon-status-lobby.component';
import { IconStatusStartComponent } from './components/icon-status-start/icon-status-start.component';
import { IconStatusStopComponent } from './components/icon-status-stop/icon-status-stop.component';
import { IconSuccessComponent } from './components/icon-success/icon-success.component';
import { IconTrashComponent } from './components/icon-trash/icon-trash.component';
import { IconEyeComponent } from './components/icon-eye/icon-eye.component';
import { IconMenuComponent } from './components/icon-menu/icon-menu.component';
import { IconPenComponent } from './components/icon-pen/icon-pen.component';
import { IconDeleteComponent } from './components/icon-delete/icon-delete.component';
import { IconFileComponent } from './components/icon-file/icon-file.component';
import { IconFileSmallComponent } from './components/icon-file-small/icon-file-small.component';
import { IconCheckmarkComponent } from './components/icon-checkmark/icon-checkmark.component';
import { IconChequeComponent } from './components/icon-cheque/icon-cheque.component';
import { IconDebitCardComponent } from './components/icon-debit-card/icon-debit-card.component';
import { IconBankComponent } from './components/icon-bank/icon-bank.component';
import { IconMiniChequeComponent } from './components/icon-mini-cheque/icon-mini-cheque.component';
import { IconPaybeeLogoComponent } from './components/icon-paybee-logo/icon-paybee-logo.component';
import { IconPaybeeTextComponent } from './components/icon-paybee-text/icon-paybee-text.component';


import { IconCampaignDonationComponent } from './components/campaign-donation/campaign-donation.component';
import { IconCampaignPeerToPeerComponent } from './components/campaign-peer-to-peer/campaign-peer-to-peer.component';
import { IconCampaignTicketingComponent } from './components/campaign-ticketing/campaign-ticketing.component';
import { IconCampaignLongPledgeComponent } from './components/campaign-long-pledge/campaign-long-pledge.component';
import { IconCampaignAuctionComponent } from './components/campaign-auction/campaign-auction.component';
import { IconCampaignHinduTemplePujaComponent } from './components/campaign-hindu-temple-puja/campaign-hindu-temple-puja.component';
import { IconConfirmComponent } from './components/icon-confirm/icon-confirm.component';
import { IconCancelComponent } from './components/icon-cancel/icon-cancel.component';
import { IconBlockComponent } from './components/icon-block/icon-block.component';
import { IconBinComponent } from './components/icon-bin/icon-bin.component';
import { IconInPersonComponent } from './components/icon-in-person/icon-in-person.component';
import { IconVirtualComponent } from './components/icon-virtual/icon-virtual.component';
import { IconWinnerDeclaredComponent } from './components/icon-winner-declared/icon-winner-declared.component';
import { IconSoldComponent } from './components/icon-sold/icon-sold.component';
import { IconSilentAuctionClosedComponent } from './components/icon-silent-auction-closed/icon-silent-auction-closed.component';
import { IconEarthPaletteComponent } from './components/icon-earth-palette/icon-earth-palette.component';
import { IconHolidaysPaletteComponent } from './components/icon-holidays-palette/icon-holidays-palette.component';
import { IconMinimalPaletteComponent } from './components/icon-minimal-palette/icon-minimal-palette.component';
import { IconOceanPaletteComponent } from './components/icon-ocean-palette/icon-ocean-palette.component';
import { IconTiffanyPaletteComponent } from './components/icon-tiffany-palette/icon-tiffany-palette.component';
import { IconPurplePaletteComponent } from './components/icon-purple-palette/icon-purple-palette.component';
import { IconFacebookComponent } from './components/icon-facebook/icon-facebook.component';
import { IconTwitterComponent } from './components/icon-twitter/icon-twitter.component';
import { IconMailComponent } from './components/icon-mail/icon-mail.component';
import { IconCopyComponent } from './components/icon-copy/icon-copy.component';
import { IconLocationComponent } from './components/icon-location/icon-location.component';
import { IconCalendarComponent } from './components/icon-calendar/icon-calendar.component';
import { IconPositiveImpactPaletteComponent } from './components/icon-positive-impact-palette/icon-positive-impact-palette.component';
import { IconEmpowerPaletteComponent } from './components/icon-empower-palette/icon-empower-palette.component';
import { IconDeleteChipsComponent } from './components/icon-delete-chips/icon-delete-chips.component';
import { IconLightBulbComponent } from './components/icon-light-bulb/icon-light-bulb.component';
import { GavelAuctionComponent } from './components/gavel-auction/gavel-auction.component';
import { InPersonHybridIconComponent } from './components/in-person-hybrid-icon/in-person-hybrid-icon.component';
import { IconCopySomeComponent } from './components/icon-copy-some/icon-copy-some.component';
import { IconCopyAllComponent } from './components/icon-copy-all/icon-copy-all.component';
import { GavelAuctionSmallComponent } from './components/gavel-auction-small/gavel-auction-small.component';
import { UpRightFromSquareComponent } from './components/up-right-from-square/up-right-from-square.component';
import { IconCopyUnsoldComponent } from './components/icon-copy-unsold/icon-copy-unsold.component';

@NgModule({
  declarations: [
    IconTimeElapsedComponent,
    IconGoalComponent,
    IconUsersOnlineComponent,
    IconAuctionComponent,
    IconDonationComponent,
    IconLastHeroComponent,
    IconSilentComponent,
    IconStatusLobbyComponent,
    IconStatusStartComponent,
    IconStatusStopComponent,
    IconTrashComponent,
    IconEyeComponent,
    IconMenuComponent,
    IconPenComponent,
    IconFileComponent,
    IconFileSmallComponent,
    IconCheckmarkComponent,
    IconChequeComponent,
    IconDebitCardComponent,
    IconBankComponent,
    IconMiniChequeComponent,
    IconPaybeeLogoComponent,
    IconPaybeeTextComponent,
    IconCampaignDonationComponent,
    IconCampaignPeerToPeerComponent,
    IconCampaignTicketingComponent,
    IconCampaignLongPledgeComponent,
    IconCampaignAuctionComponent,
    IconCampaignHinduTemplePujaComponent,
    IconConfirmComponent,
    IconCancelComponent,
    IconBlockComponent,
    IconBinComponent,
    IconInPersonComponent,
    IconVirtualComponent,
    IconWinnerDeclaredComponent,
    IconSoldComponent,
    IconSilentAuctionClosedComponent,
    IconEarthPaletteComponent,
    IconHolidaysPaletteComponent,
    IconMinimalPaletteComponent,
    IconOceanPaletteComponent,
    IconTiffanyPaletteComponent,
    IconFacebookComponent,
    IconTwitterComponent,
    IconMailComponent,
    IconCopyComponent,
    IconLocationComponent,
    IconCalendarComponent,
    IconPurplePaletteComponent,
    IconPositiveImpactPaletteComponent,
    IconEmpowerPaletteComponent,
    IconLightBulbComponent,
    GavelAuctionComponent,
    InPersonHybridIconComponent,
    GavelAuctionSmallComponent,
    UpRightFromSquareComponent,
  ],
    imports: [
        CommonModule,
        IconSuccessComponent,
        IconCopySomeComponent,
        IconCopyAllComponent,
        IconCopyUnsoldComponent,
        IconDeleteComponent,
    ],
  exports: [
    IconTimeElapsedComponent,
    IconGoalComponent,
    IconUsersOnlineComponent,
    IconAuctionComponent,
    IconDonationComponent,
    IconLastHeroComponent,
    IconSilentComponent,
    IconStatusLobbyComponent,
    IconStatusStartComponent,
    IconStatusStopComponent,
    IconSuccessComponent,
    IconTrashComponent,
    IconEyeComponent,
    IconMenuComponent,
    IconPenComponent,
    IconDeleteComponent,
    IconFileComponent,
    IconFileSmallComponent,
    IconCheckmarkComponent,
    IconBankComponent,
    IconDebitCardComponent,
    IconChequeComponent,
    IconPaybeeLogoComponent,
    IconPaybeeTextComponent,
    IconCampaignDonationComponent,
    IconCampaignPeerToPeerComponent,
    IconCampaignTicketingComponent,
    IconCampaignLongPledgeComponent,
    IconCampaignAuctionComponent,
    IconCampaignHinduTemplePujaComponent,
    IconConfirmComponent,
    IconCancelComponent,
    IconMiniChequeComponent,
    IconBlockComponent,
    IconBinComponent,
    IconVirtualComponent,
    IconInPersonComponent,
    IconWinnerDeclaredComponent,
    IconSoldComponent,
    IconSilentAuctionClosedComponent,
    IconEarthPaletteComponent,
    IconOceanPaletteComponent,
    IconHolidaysPaletteComponent,
    IconMinimalPaletteComponent,
    IconTiffanyPaletteComponent,
    IconPurplePaletteComponent,
    IconFacebookComponent,
    IconTwitterComponent,
    IconMailComponent,
    IconCopyComponent,
    IconLocationComponent,
    IconCalendarComponent,
    IconPositiveImpactPaletteComponent,
    IconEmpowerPaletteComponent,
    IconLightBulbComponent,
    GavelAuctionComponent,
    InPersonHybridIconComponent,
    IconCopySomeComponent,
    IconCopyUnsoldComponent,
    IconCopyAllComponent,
    GavelAuctionSmallComponent,
    UpRightFromSquareComponent
  ]
})
export class IconModule { }
